/**
 * @package   ats
 * @copyright Copyright (c)2011-2026 Nicholas K. Dionysopoulos / Akeeba Ltd
 * @license   GNU General Public License version 3, or later
 */

"use strict";

[].slice.call(document.querySelectorAll(".atsCannedReplyUse")).forEach(function (el)
{
    el.addEventListener("click", function (event)
    {
        event.preventDefault();

        var editor  = Joomla.getOptions('atsParentEditor');
        var id      = event.currentTarget.dataset.cannedreplyid ?? 0;
        var content = document.getElementById('atsreply' + id).innerHTML;

        window.parent.atsInsertCannedReplyIntoEditor(editor, content);

        return false;
    });
});